module.exports = __webpack_public_path__ + "img/4x AE-150-M.8ba3a413.svg";